import { useState } from "react";
import { Note } from "../../../helbest";

const useModalLocation = (
  redux_set_store,
  sliderFunction,
  toInvisible
) => {
  const [city_list, set_city_list] = useState([]);
  const [country_list] = useState([]);
  const [selected_city, set_selected_city] = useState(null);
  const [selected_country, set_selected_country] = useState(null);
  // const getProvince = () => {
  //   API.get
  //     .locationProvinces()
  //     .then((response) => {
  //       if (response.success) {
  //           set_country_list(response.data);
  //           const qs = parse(history?.location.search);
  //           if (qs.prov && isNumber(qs.prov)) {
  //             const _prov_id = parseInt(qs.prov);
  //             const _prov = response.data.find((item) => item.id === _prov_id);
  //             if (_prov) {
  //               set_selected_country(_prov_id);
  //               set_selected_city(null);
  //               set_city_list([]);
  //               getCity(_prov.id);
  //             }
  //           }
          
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("Error : ", error);
  //     });
  // };

  // const getCity = (province_id = 1) => {
  //   API.get
  //     .locationCities(province_id)
  //     .then((response) => {
  //       if (response.success) {
  //         set_city_list(response.data);
  //         if (response.data.length === 1) {
  //             const qs = parse(history?.location.search);
  //             if (qs.prov && isNumber(qs.prov)) {
  //               set_store();
  //             }
  //         }
  //           const qs = parse(history?.location.search);
  //           if (qs.city && isNumber(qs.city)) {
  //             const _city_id = parseInt(qs.city);
  //             const _city = response.data.find((item) => item.id === _city_id);
  //             if (_city) {
  //               set_selected_city(_city_id);
  //               set_store();
  //             }
  //           }
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("Error : ", error);
  //     });
  // };

  const select_country = async (e) => {
    set_selected_country(e);
    set_selected_city(null);
    set_city_list([]);
    // getCity(e);
  };

  const select_city = async (e) => {
    set_selected_city(e);
  };

  const set_store = () => {
    if (!selected_country || !selected_city) {
      Note.error("please enter your preffered country and region.");
      return;
    }
    const country_name = country_list.find(pn => pn.id === parseInt(selected_country)).name;
    const city_name = city_list.find(pn => pn.id === parseInt(selected_city)).name;
    redux_set_store(
      selected_country,
      selected_city,
      "",
      country_name,
      city_name
    );
    // categoryFunction(selected_city);
    sliderFunction();
    toInvisible();
  };

  // useEffect(() => {
  //   getProvince();
  //   // eslint-disable-next-line
  // }, []);

  return [
    city_list,
    country_list,
    selected_city,
    selected_country,
    select_country,
    select_city,
    set_store,
  ];
};

export default useModalLocation;
